var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[_vm._v(" 허용되지 않은 페이지 입니다. ")])}
var staticRenderFns = []

export { render, staticRenderFns }